//FUNCTIONS
import React from 'react';

//TYPES
import { AtributesProps } from '../../../store/modules/product/types';

//STYLES
import { TableEspecification } from './styles';

interface EspecificationItemProps {
    especificationItem: AtributesProps[];
}

const EspecificationItem: React.FC<EspecificationItemProps> = ({ especificationItem }: EspecificationItemProps) => {

    return (
        <TableEspecification>
            {
                especificationItem.map(item => {
                    return (
                        <div key={`${item.label}-${item.value}`}>
                            <span><h4>{item.label}:</h4></span>
                            <span>{item.value}</span>
                        </div>
                    )
                })
            }
        </TableEspecification>
    )
};

export default EspecificationItem;